import React, { useEffect } from 'react'
import Header from '../../../headerone/Main'
import Bredcom from '../../../Bredcom/Main'
import TenantRightsRentalAssistanceDetails from '../../subdepartmentdetails/TenantRightsRentalAssistance'


function TenantRightsRentalAssistance() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Tenant Rights and Rental Assistance || Housing and Community Development";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="Housing"
            title="Tenant Rights Rental Assistance"
            subtitledown="Department of Housing & Community Development"
           />
            <TenantRightsRentalAssistanceDetails/>
        </div>
    </>
  )
}

export default TenantRightsRentalAssistance